<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <quill-editor [(ngModel)]="text" [modules]="modules" placeholder="Escribe tu texto aquí"></quill-editor>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="activeModal.close()"><span class="btn-label"><i class="ti-close"></i></span>{{'common.cancel' | translate}}</button>
  <button type="button" class="btn btn-success" (click)="save()"><span class="btn-label"><i class="ti-save"></i></span>{{'common.save' | translate}}</button>
</div>